import axios from 'axios'

const URL_NETATMO = process.env.VUE_APP_BACKEND_URL + "/netatmo/api"
const BACKEND_URL = process.env.VUE_APP_BACKEND_URL
const STATE = "tgS3k9iju4CB_K9l"

// Le token est ajouté automatiquement depuis l'intercepteur axios dans ttboxservice
export default {
    url: URL_NETATMO,
    state: STATE,
    lireHomeData(){
        return axios.post(`${URL_NETATMO}/homesdata`, {})
    },
    lireHomeStatus(idHome){
        return axios.post(`${URL_NETATMO}/homestatus`, { home_id: idHome})
    },
    async lireStatusThermostat(){
        var status = {}
        try {
            var homeData = await this.lireHomeData()
            var homeStatus = await this.lireHomeStatus(homeData.data.body.homes[0].id)
            // Données de la room 0
            status = {
                home_id: homeData.data.body.homes[0].id,
                room_id: homeStatus.data.body.home.rooms[0].id,
                status: homeStatus.data.status,
                therm_measured_temperature: homeStatus.data.body.home.rooms[0].therm_measured_temperature,
                therm_setpoint_temperature: homeStatus.data.body.home.rooms[0].therm_setpoint_temperature,
                therm_setpoint_mode: homeStatus.data.body.home.rooms[0].therm_setpoint_mode,
                therm_setpoint_start_time: homeStatus.data.body.home.rooms[0].therm_setpoint_start_time,
                therm_setpoint_end_time: homeStatus.data.body.home.rooms[0].therm_setpoint_end_time
            }
            // Données du thermostat et du relais
            homeStatus.data.body.home.modules.forEach((module) => {
                if (module.type === "NATherm1") {
                    status.battery_level = module.battery_level
                    status.reachable = module.reachable
                    status.boiler_status = module.boiler_status
                    status.idModule = module.id
                    status.idDevice = module.bridge
                }
                if (module.type === "NAPlug") {
                    status.wifi_strength = module.wifi_strength
                }
            })
        } catch(e) {
            status.erreur = true
        }
        return status
    },
    ecrireModeThermostat(idHome, mode){
        return axios.post(`${URL_NETATMO}/setthermmode`, { home_id: idHome, mode: mode })
    },
    ecrireConsigneThermostat(idHome, idRoom, mode, temp, endtime) {
        return axios.post(`${URL_NETATMO}/setroomthermpoint`, { home_id: idHome, room_id: idRoom, mode: mode, temp: temp, endtime: endtime })
    },
    lireDonnees(idDevice, idModule, scale, type, timestampDebut, timestampFin){
        return axios.post(`${URL_NETATMO}/getmeasure?device_id=${idDevice}&module_id=${idModule}&scale=${scale}&type=${type}&date_begin=${timestampDebut}&date_end=${timestampFin}&optimize=false`)
    },
    lireDonneesPiece(idHome, idRoom, scale, type, timestampDebut, timestampFin) {
        return axios.post(`${URL_NETATMO}/getroommeasure?home_id=${idHome}&room_id=${idRoom}&scale=${scale}&type=${type}&date_begin=${timestampDebut}&date_end=${timestampFin}&optimize=false`)
    },
    lireNetAtmoAuthentication() {
        return axios.get(`${BACKEND_URL}/netatmo/authentication`)
    },
    netAtmoAuthenticate(code) {
        return axios.post(`${BACKEND_URL}/netatmo/authentication`, {code: code})
    },
    redirectToNetatmoOAuth2Dialog(clientId, scope, redirectUri) {
        return `https://api.netatmo.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${STATE}`
    }
}
